<script lang="ts">
  import type { Props } from './business-item.types'

  const { title, description }: Props = $props()
</script>

<div
  class="business-item | group/business-item relative w-full cursor-default overflow-hidden rounded-xl border border-gray-100 transition"
>
  <div class="business-item__content | relative z-10 size-full min-h-[220px] p-6 backdrop-blur-md">
    <p class="business-item__title | mb-2 min-h-[28px] text-lg font-medium sm:text-xl">
      <span class="text-brand-600 group-hover/business-item:text-brand">{title}</span>
    </p>

    <div
      class="business-item__description | text-sm font-medium text-gray-600 transition group-hover/business-item:text-gray-900"
    >
      <p>
        {description}
      </p>
    </div>
  </div>
</div>
